import {UserCreateModel} from '../../shared/services/user/user.create.model';
import {UserModel} from '../../shared/services/user/user.model';
import {UserPasswordModel} from '../../shared/services/user/user.password.model';
import {WebchargeStatus} from '../../shared/services/webcharge/webchargeStatus.enum';
import {PreorderStatus} from '../../shared/services/preorder/preorderStatus.enum';

export class GetPreorders {
  static readonly type = '[preorder] get preorders';
  constructor(public page?: number, public size?: number, public reference?: string, public status?: PreorderStatus) {}
}

export class GetPreorderDetail {
  static readonly type = '[preorder] get preorder details';
  constructor(public reference: string) {}
}
